export default "__VITE_ASSET__5703e453__"